// Shared helpers for the CP2020 equipment cost readout.
//
// Each equipment editor computes its own subtotal on serialize and emits it for
// the equipment-costs card to aggregate. These keep the cost rule (strict numeric
// parse, the event shape) in one place.

// Strict cost parse: only a clean integer string counts; anything with letters,
// symbols, or blank contributes 0. So "500eb" or "~500" are deliberately ignored
// — a GM should enter clean numbers to have them summed.
export function strictNum(value) {
  return /^\d+$/.test(String(value ?? "").trim()) ? Number(value) : 0
}

// Emit an equipment subtotal for the cp2020--equipment-costs aggregator.
export function emitEquipmentCost(type, subtotal) {
  window.dispatchEvent(new CustomEvent("cp2020:equipment-cost", {
    detail: { type, subtotal },
  }))
}
